import React from 'react';
import { useRouter } from 'next/router';
import { getCurrentUser } from 'components/users/WithCurrentUser/WithCurrentUser';

import AboutHeader from 'components/about/header/Header';
import AboutFooter from 'components/about/footer/AboutFooter';
import PricingPlans from './pricing-plans/PricingPlans';

export default function PricingPage() {
  const router = useRouter();
  const currentUser = getCurrentUser();

  const handleFreePlanClick = () => {
    if (currentUser) {
      router.push('/');
    } else {
      router.push('/signin');
    }
  };

  const handleProPlanClick = () => {
    if (currentUser) {
      router.push('/');
    } else {
      router.push('/signin');
    }
  };

  return (
    <>
      <AboutHeader />
      <PricingPlans onFreePlanClick={handleFreePlanClick} onProPlanClick={handleProPlanClick} />
      <AboutFooter />
    </>
  );
}
